import { CurrentAccountState } from 'src/states';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';
import { ClearCurrentAccount } from 'src/states/current-account/current-account.actions';

export const pscSearchClearCurrentLocationGuard = (): true => {
  const store = inject(Store);
  const userLocation = store.selectSnapshot(CurrentAccountState.userLocation);

  if (userLocation) {
    store.dispatch(new ClearCurrentAccount());
  }

  return true;
};
